import { createSelector } from "@reduxjs/toolkit";

import type { WidgetProps } from "legacy/widgets";
import type { AppState } from "store/types";

export const selectAiState = (state: AppState) => state.ai;

export const selectIsEditingWithAi = createSelector(selectAiState, (state) => {
  return state.actionsRequestId !== undefined;
});

export const selectAiWidgetChangesById = createSelector(
  selectAiState,
  (state) => {
    if (!state.focusedEntityId || !state.widgetChanges) {
      return undefined;
    }
    return state.widgetChanges as Record<
      string,
      Partial<Omit<WidgetProps, "children">>
    >;
  },
);
